import { Injectable, signal } from '@angular/core';

/** 一次导出预览要展示的东西：就是刚写进 xlsx 的那张表 */
export interface DemoExportPreviewPayload {
  /** 文件名（含 .xlsx） */
  fileName: string;
  /** 工作表名，显示在弹窗底部的 sheet 标签上 */
  sheetName: string;
  /** 表头 */
  headers: string[];
  /** 数据行，每行和 headers 一一对应 */
  rows: string[][];
}

/**
 * 演示环境的「导出预览」弹窗的数据中转站。
 *
 * 为什么需要它：导出这件事发生在 `PromotionService.exportToExcel()` 里（服务层），
 * 而弹窗得挂在根组件上（要盖住整页）。两边隔着组件树，用一个 root 级服务传一下最省事。
 *
 * 🔴 只在演示环境用。真实环境导出完只该有个「导出成功」的提示，
 *    再弹一层表格纯属打扰 —— 所以 `open()` 由调用方自己按环境判过再调。
 */
@Injectable({
  providedIn: 'root',
})
export class DemoExportPreviewService {
  private readonly payloadSignal = signal<DemoExportPreviewPayload | null>(null);

  /** 当前要预览的表；null = 弹窗关着 */
  readonly payload = this.payloadSignal.asReadonly();

  open(payload: DemoExportPreviewPayload): void {
    this.payloadSignal.set(payload);
  }

  close(): void {
    this.payloadSignal.set(null);
  }
}
